module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/step01-7e0a251af8601d18aa1e5e9133099653.png";